import { useCallback, useRef, useState } from 'react';
import { defineds } from 'js/components/elements/datepicker/defaultRanges';
import { normalizeDateRange } from 'js/components/data_flows/cards/FlowInsights/utils';

export const useDateRange = (resource: any, dataSets: { [x: string]: any }) => {
  const resourceId = resource?.id;
  const resourceType = resource?.type;
  const entity = resourceType === 'DATA_SET' ? dataSets[resourceId] : resource;

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const initialStartDate = entity?.created_at
    ? new Date(entity.created_at)
    : defineds.startOfLifetime;

  const initialDateRange = {
    startDate: initialStartDate,
    endDate: defineds.endOfToday,
    key: 'selection',
  };

  const dirtyDateRange = useRef(false);
  const [dateRange, setDateRange] = useState(initialDateRange);

  const _onRangeChange = useCallback(
    (value: any) => {
      setDateRange(value);
      dirtyDateRange.current = !!value;
    },
    [setDateRange],
  );

  const normalizeWithTimezone = useCallback(
    (startDate: string, endDate: string) => {
      return normalizeDateRange(startDate, endDate, userTimeZone);
    },
    [userTimeZone],
  );

  return {
    range: dateRange,
    isDirty: dirtyDateRange.current,
    onRangeChange: _onRangeChange,
    initialStartDate,
    initialRange: initialDateRange,
    normalizeDateRange: normalizeWithTimezone,
  };
};
